import { render } from "./EditionForm.vue?vue&type=template&id=42ea3ba4&ts=true"
import script from "./EditionForm.vue?vue&type=script&lang=ts"
export * from "./EditionForm.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/arkindex/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__